import dayjs from "dayjs";

/**
 * A block whose dates have passed can no longer affect availability — the
 * backend only ever compares blocks against the requested window. Listing it
 * as "active" is misleading, so it's grouped with the past ones instead.
 */
export function isBlockPast(block) {
    if (block.blockType === "range") {
        return dayjs(block.endDate).isBefore(dayjs(), "day");
    }

    const dates = block.specificDates || [];
    if (!dates.length) return false;
    return dates.every((d) => dayjs(d).isBefore(dayjs(), "day"));
}

/** An active block whose dates include today, i.e. the car can't be booked right now. */
export function isBlockInEffectToday(block) {
    if (!block?.isActive) return false;

    const today = dayjs();
    if (block.blockType === "range") {
        return !today.isBefore(dayjs(block.startDate), "day") && !today.isAfter(dayjs(block.endDate), "day");
    }
    return (block.specificDates || []).some((d) => dayjs(d).isSame(today, "day"));
}

export function formatBlockDates(block) {
    if (block.blockType === "range") {
        const start = dayjs(block.startDate).format("MMM D, YYYY");
        const end = dayjs(block.endDate).format("MMM D, YYYY");
        return `${start} → ${end}`;
    }
    return (block.specificDates || []).map((d) => dayjs(d).format("MMM D, YYYY")).join(", ");
}

export function getBlockReasonLabel(reason, t) {
    const reasonLabels = {
        maintenance: t("carDetail.blockReasonMaintenance"),
        personal_use: t("carDetail.blockReasonPersonalUse"),
        accident_repair: t("carDetail.blockReasonAccidentRepair"),
        documentation_issue: t("carDetail.blockReasonDocumentation"),
        other: t("carDetail.blockReasonOther"),
        external_booking: t("carDetail.blockReasonExternalBooking"),
    };
    return reasonLabels[reason] || reason;
}
